import SleekSurveyProxy from "@/proxies/back-end/survey/sleek-survey";

const initialState = {
  isSleekSurveyEnabled: false,
  isSleekSurveyDisplayed: false,
  generalSurvey: [],
  urlVisits: []
};
const state = initialState;

const getters = {
  isSleekSurveyDisplayed: (state) => state.isSleekSurveyDisplayed,
  getGeneralSurvey: (state) => state.generalSurvey,
  isSleekSurveyEnabled: (state) => state.isSleekSurveyEnabled,
  getUrlVisits: (state) => state.urlVisits,
};

const actions = {
  async showSleekSurvey({ commit }, payload) {
    commit("activateSurvey", payload);
  },
  async enableSleekSurvey({ commit }, payload) {
    commit("enableSurvey", payload);
  },
  async setSleekSurvey({ commit }, configs) {
    const {category, survey_key, version} = configs.value;
    const sleekSurveyPath = `survey?category=${category}&version=${version}&survey_key=${survey_key}`;
    const sleekProxy = new SleekSurveyProxy();
    const generalSurvey = await sleekProxy.getSurveyByVersionAndKey(sleekSurveyPath);
    commit("setSurveyList", generalSurvey);
  },
  async submitSurveyRating({ commit }, payload) {
    const sleekProxy = new SleekSurveyProxy();
    const response = await sleekProxy.submitSurveyRatings(payload);
    return response;
  },
  recordUrlVisit({ commit }, payload) {
    // Retrieve the existing array from localStorage (if any)
    const visitedUrlsJSON = localStorage.getItem("urlVisited");
    const visitedUrls = visitedUrlsJSON ? JSON.parse(visitedUrlsJSON) : [];
    // Add the new URL to the array
    visitedUrls.push(payload);
    const mappedVisits = visitedUrls.map(url => {
      let isLastVisited = false;
      let time_spent_in_sec = url.time_spent_in_sec;
      if (url.is_last_visited) {
        const first_visit = new Date(url.dateVisit);
        const latest_visit =  payload.dateVisit;
        const timeDifferenceInMillis = latest_visit.getTime() - first_visit.getTime();
        time_spent_in_sec = timeDifferenceInMillis / 1000;
      }
      if (payload.fullPath === url.path) {
        isLastVisited = true;
      }
      return {
        fullPath: url.fullPath,
        is_last_visited: isLastVisited,
        dateVisit: url.dateVisit,
        time_spent_in_sec
      }
    });
    // Save the updated array in localStorage
    localStorage.setItem("urlVisited", JSON.stringify(mappedVisits));
    commit("storeUrlVisits", mappedVisits);
  },
};

const mutations = {
  activateSurvey(state, payload) {
    state.isSleekSurveyDisplayed = payload;
  },
  setSurveyList(state, payload) {
    state.generalSurvey = payload;
  },
  enableSurvey(state, payload) {
    state.isSleekSurveyEnabled = payload;
  },
  storeUrlVisits(state, payload) {
    state.urlVisits = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
